export type FormattedDate = {
  year: number;
  month: number;
  day: number;
  hours: string;
  minutes: string;
  seconds: string;
  weekday: string;
};

export default function dateTimeFromUnix(time: number, tz: string): FormattedDate {
  const timestamp = time * 1000;
  const date = new Date(timestamp);

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    weekday: "long",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);

  const result: Record<string, string> = {};
  parts.forEach((part) => {
    if (part.type !== "literal" && part.value !== undefined) {
      result[part.type] = part.value;
    }
  });

  return {
    year: parseInt(result.year, 10),
    month: parseInt(result.month, 10),
    day: parseInt(result.day, 10),
    hours: result.hour,
    minutes: result.minute,
    seconds: result.second,
    weekday: result.weekday,
  };
}
